import {Pipe, PipeTransform} from '@angular/core';
import {RouteService} from '../services/route.service';

@Pipe({
    name: 'dispatchGroupTitle'
})
export class DispatchGroupTitlePipe implements PipeTransform {
    constructor(private routeService: RouteService) {}

    transform(id: number): any {
        const dispatchGroups = this.routeService.getDispatchGroup();
        return dispatchGroups.filter(dispatchGroup => dispatchGroup.id === id)[0].title;
    }
}
